module.exports = __webpack_public_path__ + "img/eosc-synergy-high-contrast.bac312fe.png";